import Accordion from "../components/Accordion";
import { EXPERIENCE } from "../utils/constants";
import Title from "./Title";

export default function Experience() {
    return (
        <div className="flex flex-col md:flex-row gap-6 md:justify-between relative my-16 md:my-28">
            <Title text="My Experience" image="/laptop-emojii.png" alt="Experience" className="md:sticky top-[75px] md:pt-4 pt-0" />
            <div className="md:w-[60%]">
                <Accordion items={EXPERIENCE} />
            </div>
        </div>
    );
}
